// extracted by mini-css-extract-plugin
export default {"content":"XxcXP","appear-from-above":"GpjG1","appearFromAbove":"GpjG1"};